import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "city",
    serviceName: "graphql",
    query: gql`
      query city(
        $ids: [String]
        $title: String
        $page: Int
        $limit: Int
        $state_id: String
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        city(
          ids: $ids
          title: $title
          page: $page
          limit: $limit
          state_id: $state_id
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          data {
            id
            title
            state {
              title
            }
            media {
              id
              full_url
            }
          }
          total
          last_page
        }
      }
    `,
  },
  delete: {
    name: "deleteCity",
    serviceName: "admin",
    query: gql`
      mutation deleteCity($ids: [String]!) {
        deleteCity(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  assignment: {
    name: "city",
    serviceName: "grapghql",
    query: gql`
      query city($ids: [String]) {
        city(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
